import { _GROUPS } from "@/store/_PERMISSIONS"

// -- FIELDS
const _FIELDS = [
  {
    label: "Nome",
    name: "nome",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "Dádivas",
    name: "dadivas",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Nome",
    align: "left",
    value: "nome"
  },
  {
    text: "Dádivas",
    align: "left",
    value: "dadivas"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const GALARDAO = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default GALARDAO
